import { NJButton } from '@engie-group/fluid-design-system-react';
import { UMIcon } from '../../urbanmap/_components';
import { UMR } from '../proposition-c/tokens';

const DANGER = 'var(--nj-core-color-red-700, #b2201c)';

/** Confirmation d'une action destructive — la suppression d'un projet est définitive. */
export function ConfirmDeleteDialog({
  projectName, planCount, sharedWith, onCancel, onConfirm,
}: {
  projectName: string;
  planCount: number;
  sharedWith: number;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`Supprimer « ${projectName} »`}
      style={{ position: 'fixed', inset: 0, zIndex: 80, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      onClick={onCancel}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        style={{ width: 440, maxWidth: '100%', background: UMR.white, border: `1px solid ${UMR.border}`, borderTop: `4px solid ${DANGER}`, padding: 20, display: 'flex', flexDirection: 'column', gap: 16, fontFamily: UMR.font }}
      >
        <div style={{ display: 'flex', gap: 12 }}>
          <UMIcon name="delete" size={24} color={DANGER} />
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: UMR.textStrong }}>Supprimer « {projectName} » ?</div>
            <div style={{ marginTop: 6, fontSize: 14, lineHeight: '20px', color: UMR.textSecondary }}>
              La copie des bâtiments, les hypothèses et {planCount} plan{planCount > 1 ? 's' : ''} de développement
              seront perdus. {sharedWith > 0 && `Le projet est partagé avec ${sharedWith} personne${sharedWith > 1 ? 's' : ''}.`}
              {' '}Préférez l’archivage si vous voulez le retrouver plus tard.
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <NJButton label="Annuler" variant="secondary" emphasis="subtle" onClick={onCancel} />
          <NJButton label="Supprimer définitivement" variant="destructive" onClick={onConfirm} />
        </div>
      </div>
    </div>
  );
}
